import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RegistrationStepService } from "../registration-step.service";
import { QuestionRequest } from "../models/question-request.model";
import { MatDialog } from "@angular/material/dialog";
import { LoaderComponent } from "src/app/loader/loader.component";
import { AlertController, IonModal, ModalController } from '@ionic/angular';
import { TranslocoService } from "@ngneat/transloco";
import { Router } from "@angular/router";



@Component({
  selector: "app-qs-consent",
  templateUrl: "./qs-consent.component.html",
  styleUrls: ['../registration-step.component.scss']
})
export class QsConsentComponent implements OnInit {
  questionCode: string = 'Q_CONSENT';
  consentAccepted: boolean = false;
  @Input() activeLang: string = "";
  questionRequest: QuestionRequest;
  progressSpinnerDialog: any = null;
  @Output() proceedNext = new EventEmitter();

  constructor(private registrationStepService: RegistrationStepService,
     private dialog: MatDialog, 
    private alertController: AlertController, 
    private translocoService: TranslocoService,
      private router: Router,
) {}

  ngOnInit() {
    this.alertController.create({
            header: this.translocoService.translate('DIGILOCKER.HEADER'),
            message: this.translocoService.translate('DIGILOCKER.MESSAGE'),
            backdropDismiss: false,
            buttons: [
              {
                text: this.translocoService.translate('DIGILOCKER.YES'),
                handler: () => {
                  this.router.navigate(['/registration-step']);
                }
              },
              {
                text: this.translocoService.translate('DIGILOCKER.NO'),
                handler: () => {
                  window.location.href = "https://accounts.digilocker.gov.in/v3/347fc2874cffacccbf6bcc341a3daf893bd2ab1f7261ae493bd6cb4ff43e17d5--en";
                }
              }
            ]
          }).then(alert => alert.present());
  }

  async proceed() {
    if(this.consentAccepted) {
      this.questionRequest = {
        consentRequest: {
          consent: 'Y'
        }
      };
      this.displayProgressSpinner();
      this.registrationStepService.saveQuestion(this.questionCode, this.questionRequest)
      .subscribe((data) => {
        this.closeProgressSpinner();
        if(data.status === 'SUCCESS') {
          this.proceedNext.emit();
        }
        else {
          this.registrationStepService.showErrorMessage(data.errorMessage, true);
        }
      }, error => {
        console.log(error);
        this.closeProgressSpinner();
        this.registrationStepService.frontendWarningToast("error-network-related-issue", true);
      });
    }
    else {
      this.registrationStepService.frontendWarningToast("error-provide-consent", false);
    }
  }

  async displayProgressSpinner() {
    if(!this.progressSpinnerDialog) {
      this.progressSpinnerDialog = this.dialog.open(LoaderComponent, {
          disableClose: true,
          panelClass: "progressSpinner",
      });
    }
  }

  async closeProgressSpinner() {
    if(this.progressSpinnerDialog) {
      this.progressSpinnerDialog.close();
    }
  }
}